import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  max-width: 440px;

  .currency-calculator {
    direction: rtl;
    overflow: hidden;
    border: 1px solid rgba(26, 26, 28, 0.12);
    border-radius: 24px;
    background: #ffffff;
    box-shadow: 0 20px 55px rgba(26, 26, 28, 0.12);
  }

  .calculator-heading {
    padding: 28px 30px 24px;
    background: #f5f6f7;

    .eyebrow {
      color: #76777a;
      font-size: 13px;
    }

    h2 {
      margin: 7px 0 5px;
      color: #1a1a1c;
      font-size: 27px;
      line-height: 1.5;
    }

    p {
      margin: 0;
      color: #616266;
      font-size: 14px;
      line-height: 1.8;
    }
  }

  .calculator-form,
  .calculator-message {
    padding: 24px 30px 30px;
  }

  .calculator-message {
    min-height: 200px;
    color: #616266;
    text-align: center;
  }

  .calculator-message.error,
  .refresh-error {
    color: #b42318;
  }

  .refresh-error {
    margin-bottom: 15px;
    font-size: 12px;
    line-height: 1.8;
  }

  label {
    display: block;
    margin-bottom: 8px;
    color: #3d3e42;
    font-size: 14px;
  }

  select,
  input {
    width: 100%;
    height: 52px;
    border: 1px solid #d8dadd;
    border-radius: 10px;
    outline: none;
    background: #fff;
    color: #1a1a1c;
    font-family: IRANSans;
    font-size: 15px;
    box-sizing: border-box;

    &:focus {
      border-color: #1a1a1c;
      box-shadow: 0 0 0 3px rgba(26, 26, 28, 0.08);
    }
  }

  select {
    padding: 0 13px;
  }

  .direction-row {
    display: grid;
    grid-template-columns: 1fr 42px 1fr;
    align-items: center;
    gap: 10px;
    margin: 18px 0;
    color: #5f6064;
    font-size: 14px;
    text-align: center;

    button {
      width: 42px;
      height: 42px;
      border: 0;
      border-radius: 50%;
      background: #1a1a1c;
      color: #fff;
      cursor: pointer;
      font-family: inherit;
      font-size: 22px;
      line-height: 1;
    }
  }

  .amount-field {
    position: relative;

    input {
      direction: ltr;
      padding: 0 74px 0 13px;
      text-align: left;
    }

    span {
      position: absolute;
      top: 50%;
      right: 14px;
      color: #77787c;
      font-size: 13px;
      transform: translateY(-50%);
    }
  }

  .rate-row {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-top: 17px;
    color: #68696d;
    font-size: 13px;

    strong {
      color: #303135;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  .calculator-result {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    margin-top: 22px;
    padding: 17px 18px;
    border-radius: 12px;
    background: #1a1a1c;
    color: #fff;

    span {
      font-size: 14px;
    }

    strong {
      font-size: 18px;
      font-weight: 700;
      text-align: left;
    }
  }

  @media screen and (max-width: 600px) {
    max-width: none;

    .calculator-heading,
    .calculator-form,
    .calculator-message {
      padding-right: 20px;
      padding-left: 20px;
    }

    .currency-calculator {
      border-radius: 18px;
    }
  }
`;
